// extracted by mini-css-extract-plugin
module.exports = {"status":"styles__status___2n9vY","online":"styles__online___2NrIt"};